import { Box, Flex, Text } from "@chakra-ui/react";
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMyCart } from "../../contexts/MyCartContext";

type MyCartModalProps = {
  variant?: "menu" | "drawer";
  onDialogOpenChange?: (open: boolean) => void;
};

export default function MyCartModal({
  variant = "menu",
}: MyCartModalProps) {
  const { count } = useMyCart();
  const navigate = useNavigate();
  const isDrawer = variant === "drawer";
  const iconSize = isDrawer ? 18 : 17;

  return (
    <Flex
      px={isDrawer ? "0.95rem" : "0.75rem"}
      py={isDrawer ? "0.78rem" : "0.68rem"}
      rounded={isDrawer ? "0.85rem" : "lg"}
      gap="0.75rem"
      align="center"
      cursor="pointer"
      color={isDrawer ? "greyscale.text.body" : "#374151"}
      border={isDrawer ? "1px solid transparent" : undefined}
      transition={
        isDrawer
          ? "all 0.18s ease"
          : "background 0.16s ease, color 0.16s ease, border-color 0.16s ease"
      }
      _hover={
        isDrawer
          ? {
              bg: "rgba(34,197,94,0.06)",
              borderColor: "rgba(34,197,94,0.16)",
              color: "greyscale.text.title",
              transform: "translateX(2px)",
              boxShadow: "0 6px 14px rgba(15,23,42,0.04)",
            }
          : {
              bg: "rgba(34,197,94,0.06)",
              color: "#15803D",
            }
      }
      onClick={() => navigate("/my-cart")}
    >
      <Flex
        position="relative"
        flexShrink={0}
        w={isDrawer ? "1.55rem" : "1.45rem"}
        h={isDrawer ? "1.55rem" : "1.45rem"}
        align="center"
        justify="center"
        color="currentColor"
      >
        <ShoppingCart size={iconSize} />
        {count > 0 && (
          <Box
            position="absolute"
            top="-0.55rem"
            right="-0.65rem"
            w="1.1rem"
            h="1.1rem"
            rounded="full"
            bg="#EA580C"
            color="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="0.58rem"
            fontWeight="900"
            lineHeight="1"
            border="1px solid white"
            flexShrink={0}
          >
            {count}
          </Box>
        )}
      </Flex>
      <Box minW={0}>
        <Text fontSize="0.875rem" fontWeight="750" lineHeight="1.25">
          My Cart
        </Text>
        <Text
          mt="0.12rem"
          fontSize="0.75rem"
          fontWeight="500"
          color="#64748B"
          lineHeight="1.35"
        >
          Pending payment
        </Text>
      </Box>
    </Flex>
  );
}
